"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Overlay = function Overlay(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].background,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, props.children));
};
var _default = exports["default"] = Overlay;